import { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios"

export interface PaymentChargeLogArray {
  wmChargeId: number
  bookingId: number
  bookingNo: string
  chargeAmount: number
  currency: string
  groupId: string | null
  isActive: boolean
  isCapture: boolean
  isChargeSuccessful: boolean
  isSplitBookingCharge: boolean
  logCharacter: null | string
  paymentDate: number | null
  status: string
  stripeChargeId: null | string
  stripeCustomerId: string
  chargeCaptureAmount: number
  refundAmount: number
  stripeIntentId: string
  paymentType: string
  travellerId: number
  modifiedId: null | string | number
  isIgnore?: boolean
}

export interface PaymentTransferLogArray {
  transactionId: number
  bookingNo: string
  currency: string
  isActive: boolean
  isTransactionReverse: boolean
  isTransactionSucessfull: boolean
  logCharacter: null | string
  paymentDate: null | string
  status: string
  pmcId: string
  stripeTranferId: null | string
  transferAmount: number
  transferSendDate: number | string
  transferType: string
  transferReversedAmount: number
  note: null | string
  reason: null | string
  modifiedId: null | string | number
  length?: number
  isCancelStatus?: boolean
}

export interface StagedPaymentType {
  id: number
  travelerPaymentAmount: number
  refundAmount: number
  paymentChargeId: number
  paymentMethodId: string | null
  bookingNumber: string
  paymentMode: string | null
  paidDate: number | null
  paymentReceiptUrl: string | null
  paymentType: string
  deducted: boolean
  dueDate: string
  stageOrder: number
  brand: string | null
  last4: string | null
}

export interface GuestInfoListType {
  firstName: string
  lastName: string
  emailId: string
}

export interface CancellationPolicy {
  gracePeriod: number | null
  gracePeriodPercentage: number | null
  policy: PolicyDetail[]
}

export interface PolicyDetail {
  id: string
  category: string
  percentage: number
  validFrom: number
  validTo: number
  description: string
  updatedDt: number
}

export interface BookingExtensionType {
  id: number
  pmcId: string
  pmsUnitId: string
  bookingExtensionInitDate: number
  bookingNumber: string
  status: string
  newCheckInDate: number[]
  newCheckOutDate: number[]
  feeList: unknown[] | null
  taxList: unknown[] | null
  rentAmount: number
  requiredFeeAmount: number
  taxAmount: number
  bookingAmount: number
  whimstayTravelerServiceFeeAmount: number
  travelerPaymentAmount: number
  paymentSystemTravelerFeeAmount: number
  whimstayHostServiceFeeAmount: number
  whimstayHostProcessingFeeAmount: number
  paymentChargeLogId: number
  paymentTransferLogId: number
  paymentMode: string
  isConfirmedByPmc: boolean
  updateDt: number[]
  travelerChargeAmount: number
  prequoteId: string
  stripeFee: number
  pdp: string
  pdpFees: number
  riskRating: number
  paymentStatus: string
  stripeChargeDueDate: number
  stripeSaveAmount: number
  stripeIntentId: string
  discountPercentApplied: number
}

export interface TravelAgentInfoType {
  agentId: number
  emailId: string
  name: string
  mobileNumber: string
}

export interface PaymentBookingType {
  agentId: number | null
  bookingExtension: BookingExtensionType | null
  chargeActivityLogs: PaymentChargeLogArray[]
  transferActivityLogs: PaymentTransferLogArray[]
  stagedPaymentTransactions: StagedPaymentType[]
  bookingNumber: string
  bookingStatus: string
  finalPaymentDueDate: number
  hostCancellationFee: number
  hostCancellationFeeNote: string
  isHCFCharged: boolean
  policyNumber: number
  riskRating: number
  currentRiskRatingForIdVerification: number
  isUserIdentityVerified: boolean
  isIdVerificationByPass: boolean
  informationalTextOptIn: boolean
  isConfirmedByPmc: boolean
  marketingTextOptIn: boolean
  guestInfo: GuestInfoListType[]
  stagedPaymentConfig: {
    firstPayment: number
    secondPayment: number
  } | null
  cancellationPolicy: CancellationPolicy
  cancellationFee?: number
  cancelRequestSubmittedDate: string | null
  refundableAmount: number
  note: string | null
  reason: string | null
  bookingCancelDate: number | null
  bookingInitDate: number | null
  stagedPaymentOverride: boolean
  showStagedPaymentOverrideInfo: boolean
  sameDayIdVerificationRequired: boolean
  idVerificationRequired: boolean
  proxyEmailMappingList: Record<string, string>
  stripeConnectAccountLink: string | null
  whimstayAdjustedAmount?: number | null
  travelAgentInfo?: TravelAgentInfoType
  source: string
  agentCommission?: number
}

interface GetPaymentBookingDetailResponseData extends AxiosResponse {
  data: PaymentBookingType
}

interface GetPaymentBookingDetailResponse extends AxiosResponse {
  data: GetPaymentBookingDetailResponseData
}

export interface GetPaymentBookingDetailRequest
  extends Partial<AxiosRequestConfig> {
  bookingNumber: string
}

export function getPaymentBookingDetailApi(
  { bookingNumber, ...config }: GetPaymentBookingDetailRequest,
  axiosInstance: AxiosInstance,
): Promise<GetPaymentBookingDetailResponse> {
  return axiosInstance({
    method: "get",
    url: `admin/booking/info?bookingNumber=${bookingNumber}`,
    ...config,
  })
}
